import { createFileRoute, notFound } from "@tanstack/react-router"
import { PublicRoute } from "@/content"
import { i18n, isLocale } from "@/i18n"

export const Route = createFileRoute("/$locale")({
  ssr: true,
  // The locale lives in the URL path for public pages; validate it and make it
  // the active i18n language. An unknown segment (e.g. /fr) is a 404, not a
  // silent English fallback.
  beforeLoad: ({ params }) => {
    if (!isLocale(params.locale)) {
      throw notFound()
    }
    if (i18n.language !== params.locale) {
      void i18n.changeLanguage(params.locale)
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PublicRoute />
}
